module.exports = __webpack_public_path__ + "img/page54.83384965.gif";